"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _ScrollableList = _interopRequireDefault(require("./ScrollableList"));
var _Expandable = _interopRequireDefault(require("./Expandable"));
var _List = require("./List");
var _excluded = ["animation", "alignment", "upward", "scrollIntoView", "preload", "onPreloadStateChange", "getTogglerNode", "onFocusOut", "onChange", "highlightSelectedItem", "closeLabel", "closeButtonIcon", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react["default"].PureComponent || _react["default"].Component;
var ExpandableList = /*#__PURE__*/function (_PureComponent) {
  _inherits(ExpandableList, _PureComponent);
  var _super = _createSuper(ExpandableList);
  function ExpandableList() {
    var _this;
    _classCallCheck(this, ExpandableList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {});
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      return _this.expandable.toggle();
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "expand", function (parameters) {
      return _this.expandable.expand(parameters);
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      return _this.expandable.collapse();
    });
    _defineProperty(_assertThisInitialized(_this), "isExpanded", function () {
      return _this.expandable.isExpanded();
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "preload", function () {
      return _this.expandable.preload();
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      _this.expandable.onBlur(event);
    });
    _defineProperty(_assertThisInitialized(_this), "chooseFocusedItem", function () {
      return _this.list && _this.list.chooseFocusedItem();
    });
    _defineProperty(_assertThisInitialized(_this), "getFocusedItemIndex", function () {
      return _this.list ? _this.list.getFocusedItemIndex() : undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "focusItem", function (index) {
      return _this.list.focusItem(index);
    });
    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      return _this.list.clearFocus();
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var onEnter = _this.props.onEnter;
      switch (event.keyCode) {
        // "Escape".
        // Collapse.
        case 27:
          event.preventDefault();
          // Collapse the list if it's expanded.
          return _this.expandable.collapse();

        // "Up" arrow.
        // Select the previous item (if present).
        case 38:
        // "Down" arrow.
        // Select the next item (if present).
        case 40:
          if (_this.isExpanded()) {
            // Navigate the list (if it was already expanded).
            _this.list.onKeyDown(event);
          } else {
            // Expand the list if it's collapsed.
            event.preventDefault();
            _this.expandable.expand();
          }
          return;

        // "Enter".
        case 13:
          // Select the currently focused item.
          return _this.list && _this.list.onKeyDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "storeExpandableRef", function (ref) {
      return _this.expandable = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "storeListRef", function (ref) {
      return _this.list = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (value, index) {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        focusSelectedItem = _this$props.focusSelectedItem;
      if (onChange) {
        onChange(value, index);
      }
      if (focusSelectedItem) {
        _this.setState({
          selectedItemIndex: index
        });
      }
      _this.collapsedDueToItemBeingSelected = true;
      _this.collapse();
      _this.collapsedDueToItemBeingSelected = undefined;
    });
    // If a `<List/>` has `onChange` then it wraps `<List.Item/>`s with `<button/>`s.
    // The `onChange` added by `<ExpandableList/>` overrides the original `onChange`.
    // If there was no `onChange` — there will be one.
    // So to retain that info `hasOnChange` property is used as a workaround.
    _defineProperty(_assertThisInitialized(_this), "hasOnChange", function () {
      var onChange = _this.props.onChange;
      return !!onChange;
    });
    _defineProperty(_assertThisInitialized(_this), "onCollapse", function (parameters) {
      var onCollapse = _this.props.onCollapse;
      if (onCollapse) {
        onCollapse(_objectSpread(_objectSpread({}, parameters), {}, {
          collapsedDueToItemBeingSelected: _this.collapsedDueToItemBeingSelected
        }));
      }
      _this.setState({
        selectedItemIndex: undefined
      });
      if (_this.list) {
        _this.list.clearFocus();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onExpand", function () {
      var _this$props2 = _this.props,
        focusOnExpand = _this$props2.focusOnExpand,
        onExpand = _this$props2.onExpand,
        children = _this$props2.children;
      var selectedItemIndex = _this.state.selectedItemIndex;
      if (onExpand) {
        onExpand();
      }

      // Re-calculate `<ScrollableList/>` height.
      // Because `<ScrollableList/>` is always mounted,
      // even when collapsed, so its height should be
      // re-calculated after it's actually expanded.
      // Re-calculating `<ScrollableList/>` height
      // before focusing the list because otherwise
      // a long list wouldn't have its `max-height` set
      // and focusing it (`this.list.focus()`) could
      // result in scroll position "jump".
      _this.list.onExpand();
      if (focusOnExpand) {
        if (selectedItemIndex === undefined) {
          _this.list.focus();
        } else {
          _this.list.focusItem(selectedItemIndex);
        }
      }
    });
    return _this;
  }
  _createClass(ExpandableList, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        animation = _this$props3.animation,
        alignment = _this$props3.alignment,
        upward = _this$props3.upward,
        scrollIntoView = _this$props3.scrollIntoView,
        preload = _this$props3.preload,
        onPreloadStateChange = _this$props3.onPreloadStateChange,
        getTogglerNode = _this$props3.getTogglerNode,
        onFocusOut = _this$props3.onFocusOut,
        onChange = _this$props3.onChange,
        highlightSelectedItem = _this$props3.highlightSelectedItem,
        closeLabel = _this$props3.closeLabel,
        closeButtonIcon = _this$props3.closeButtonIcon,
        className = _this$props3.className,
        children = _this$props3.children,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_Expandable["default"], {
        ref: this.storeExpandableRef,
        animation: animation,
        alignment: alignment,
        upward: upward,
        scrollIntoView: scrollIntoView,
        preload: preload,
        onPreloadStateChange: onPreloadStateChange,
        onExpand: this.onExpand,
        onCollapse: this.onCollapse,
        getTogglerNode: getTogglerNode,
        onFocusOut: onFocusOut,
        closeLabel: closeLabel,
        closeButtonIcon: closeButtonIcon,
        className: (0, _classnames["default"])(className, 'rrui__expandable-list', {
          'rrui__expandable-list--left-aligned': alignment === 'left',
          'rrui__expandable-list--right-aligned': alignment === 'right'
        })
      }, /*#__PURE__*/_react["default"].createElement(_ScrollableList["default"], _extends({}, rest, {
        expandable: true,
        ref: this.storeListRef,
        onChange: this.onChange,
        hasOnChange: this.hasOnChange(),
        highlightSelectedItem: onChange === undefined && highlightSelectedItem === undefined ? false : highlightSelectedItem
      }), children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Using `!state.hasOwnProperty()` as "not initialized"
      // because when there's an empty option `props.value` is `undefined`.
      if (props.focusSelectedItem && (!state.hasOwnProperty('selectedItemValue') || state.selectedItemValue !== props.value)) {
        return {
          selectedItemValue: props.value,
          // `findItemIndexByValue()` must return `undefined` for "no such item".
          selectedItemIndex: (0, _List.findItemIndexByValue)(props.value, props.children)
        };
      }
      return null;
    }
  }]);
  return ExpandableList;
}(PureComponent);
_defineProperty(ExpandableList, "propTypes", {
  // Maximum items fitting the list height (scrollable).
  scrollMaxItems: _propTypes["default"].number,
  // Whether should add `margin-right` for scrollbar width on overflow.
  scrollBarPadding: _propTypes["default"].bool,
  // Preloads the contents of the expandable list
  // before it's expanded. Must return a `Promise`.
  preload: _propTypes["default"].func,
  // Whether the list items should be focused upon expand.
  focusOnExpand: _propTypes["default"].bool,
  focusSelectedItem: _propTypes["default"].bool,
  alignment: _propTypes["default"].oneOf(['left', 'right']),
  animation: _propTypes["default"].string,
  className: _propTypes["default"].string
});
_defineProperty(ExpandableList, "defaultProps", {
  alignment: 'left',
  focusOnExpand: true,
  focusSelectedItem: true
});
var _default = (0, _reactLifecyclesCompat.polyfill)(ExpandableList);
exports["default"] = _default;
//# sourceMappingURL=ExpandableList.js.map